import * as React from 'react';
import styled from 'styled-components';
import ChoiceButton from './ChoiceButton';
import ChoiceSelect from './ChoiceSelect';

const MAX_BUTTONS_SELECT_THRESHOLD = 7;

interface Props {
    buttons: string[];
    onClick: (val: any) => void;
}

interface State {}

class ChoiceButtonList extends React.Component<Props, State> {
    render() {
        const { buttons } = this.props;
        return (
            <Wrapper>
                {buttons.length >= MAX_BUTTONS_SELECT_THRESHOLD ? (
                    <ChoiceSelect buttons={buttons} onChange={this.props.onClick} />
                ) : (
                    buttons.map((button, i) => (
                        <ChoiceButton key={i} button={button} onClick={this.props.onClick} />
                    ))
                )}
            </Wrapper>
        );
    }
}

export default ChoiceButtonList;

const Wrapper = styled.div``;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/ChoiceButtonList.tsx